import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiEndpoints } from '../common/config';
@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(
    private readonly http: HttpClient,
  ) {}

  /**
   * logout password
   */
  logout(): Observable<any> {
    return this.http.patch<any>(ApiEndpoints.authentication.logout, '');
  }
}
